import menu from './menu'
import userAccount from './user-account'
import config from './config'

// Array of sections
export default [...menu, ...config, ...userAccount]
